import { createContext, useContext, useState } from 'react'

const VOLUME_STORAGE_KEY = 'player-volume'
const MUTE_STORAGE_KEY = 'player-mute'

type VolumeContextType = {
  volume: number
  muted: boolean
  updateVolume: (volume: number) => void
  updateMute: (muted: boolean) => void
}

const VolumeContext = createContext<VolumeContextType>({
  volume: 1,
  muted: false,
  updateVolume: () => {},
  updateMute: () => {},
})

export const VolumeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [volume, setVolume] = useState<number>(
    localStorage.getItem(VOLUME_STORAGE_KEY) ? Number(localStorage.getItem(VOLUME_STORAGE_KEY)) : 1,
  )
  const [muted, setMuted] = useState<boolean>(localStorage.getItem(MUTE_STORAGE_KEY) === 'true')

  const updateVolume = (volume: number) => {
    setVolume(volume)
    localStorage.setItem(VOLUME_STORAGE_KEY, volume.toString())
  }

  const updateMute = (muted: boolean) => {
    setMuted(muted)
    localStorage.setItem(MUTE_STORAGE_KEY, muted.toString())
  }

  return (
    <VolumeContext.Provider value={{ volume, muted, updateVolume, updateMute }}>
      {children}
    </VolumeContext.Provider>
  )
}

export const useVolume = () => {
  const context = useContext(VolumeContext)

  return context
}
